module.exports = __webpack_public_path__ + "static/img/1-1.b31f2e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/1-1.png
// module id = uyMT
// module chunks = 1